import { render } from "./InspecaoSecao4.vue?vue&type=template&id=a2605000&scoped=true&ts=true"
import script from "./InspecaoSecao4.vue?vue&type=script&lang=ts"
export * from "./InspecaoSecao4.vue?vue&type=script&lang=ts"

import "./InspecaoSecao4.vue?vue&type=style&index=0&id=a2605000&scoped=true&lang=css"

import exportComponent from "D:\\RopeSeguros\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2605000"]])

export default __exports__